import React, { useContext } from "react";
import { CardBody } from "reactstrap";
import echarts from "echarts/lib/echarts";
import ReactEchartsCore from "echarts-for-react/lib/core";
import { getPosition, getGrays, rgbaColor } from "../../../helpers/utils";
import AppContext from "../../../context/Context";
import emptyState from "../../../assets/img/illustrations/graphplaceholder.png";

import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

const getOption = (xAxisData, yAxisData, isDark, dataName) => {
  const grays = getGrays(true);
  const formatNumber = (num) => {
    if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "m";
    if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "k";
    return num;
  };
  const xAxisLabelRotate = xAxisData && xAxisData.length > 10 ? 90 : 0;
  return {
    tooltip: {
      trigger: "axis",
      padding: [7, 10],
      backgroundColor: grays.white,
      borderColor: grays[100],
      borderWidth: 1,
      textStyle: { color: grays.black },
      transitionDuration: 0,
      position(pos, params, dom, rect, size) {
        return getPosition(pos, params, dom, rect, size);
      },
      color: "black",
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      boundaryGap: true,
      axisPointer: {
        lineStyle: {
          color: grays["300"],
          type: "dashed",
        },
      },
      splitLine: { show: false },
      axisLine: {
        lineStyle: {
          color: rgbaColor("#000", 0.01),
          type: "dashed",
        },
      },
      axisTick: { show: false },
      axisLabel: {
        show: true,
        color: grays["600"],
        fontFamily: "'DM Sans', Arial, sans-serif",
        fontSize: 12,
        interval: 0,
        rotate: xAxisLabelRotate,
        margin: 10,
        formatter: function (value) {
          return value;
        },
      },
    },
    yAxis: {
      type: "value",
      axisPointer: { show: false },
      splitLine: { show: true },
      boundaryGap: false,
      axisLabel: {
        show: true,
        color: grays["400"],
        margin: 15,
        formatter: function (value) {
          return formatNumber(value);
        },
        style: {
          fontFamily: "'DM Sans', Arial, sans-serif"
        },
      },
      axisTick: { show: false },
      axisLine: { show: false },
    },
    series: [
      {
        type: "bar",
        barWidth: "60%",
        data: yAxisData.map((element) => {
          if (Number.isInteger(Number(element))) {
            return element;
          } else if (Number.isFinite(Number(element))) {
            return parseFloat(element).toFixed(2);
          }
        }),
        itemStyle: {
          color: "#1991ff",
          borderRadius: [8, 8, 0, 0],
        },
        hoverAnimation: true,
        name: dataName,
      },
    ],
    legend: {
      show: false,
    },
    animationDuration: 10,
    grid: {
      right: "16px",
      left: "0px",
      bottom: "20px",
      top: "12px",
      containLabel: true,
    },
  };
};

const BarGraph = ({ xAxis, yAxis, title, dataName, showLoading = false }) => {
  const { isDark } = useContext(AppContext);
  return (
    <CardBody className="h-100 p-0">
      {xAxis.length === 0 || yAxis.length === 0 ? (
        <div className="text-center p-5">
          <img src={emptyState} alt="No data" style={{ width: '150px', height: '150px' }} />
          <p>No data available</p>
        </div>
      ) : (
        <ReactEchartsCore
          echarts={echarts}
          option={getOption(xAxis, yAxis, isDark, dataName)}
          showLoading={showLoading}
          style={{ minHeight: "18.75rem" }}
        />
      )}
    </CardBody>
  );
};

export default BarGraph;
